<!--&================== TITLE ADMINISTRATOR ==================&-->
<div class="title-components">
  <h1>Papelera de reciclaje</h1>
</div>

<!--&================== CONTENT CARDS ==================&-->
<div class="Content-Tasks">
  <ng-container *ngFor="let Library of AllRecycleBin">
    <ng-container *ngFor="let Library_Admin of Library.Library">
      <div
        [routerLinkActive]="'active'"
        class="Card-Task"
      >
          <div class="Content-Card">
            <div class="Card-Notification">
              <div class="notifications button-square">
                <i class="fa-solid {{ Library_Admin.Icon }}"></i>
              </div>
            </div>
            <div class="Body-Card">
              <div class="Title-Card">
                <h2>{{ Library_Admin.Title }}</h2>
              </div>
              <div class="Subtitle-Card">
                {{ GetGreeting() }}, {{ NameUser() }},
                {{ Library_Admin.Description }}
              </div>
            </div>
          </div>
          <div class="Btn-See-Task">
            <button
              routerLink="{{ Library_Admin.RouteLink }}"
              class="Btn-Task btn-icon-text-left"
            >
              <span class="text">{{ Library_Admin.ButtonText }}</span
              ><i class="fa-solid {{ Library_Admin.IconButton }}"></i>
            </button>
          </div>
      </div>
    </ng-container>
  </ng-container>
</div>
